<!--
  功能：个人素材库
  时间：2024年12月31日 14:46:43
  版本：v1.0
-->
<template>
  <div class="wrapHeight">
    <div>
      <span class="">
        <el-checkbox
          v-if="showSelectAll"
          v-model="isSelectAll"
          @change="handleSelectAll"
          >全选</el-checkbox
        >
      </span>
    </div>
    <div class="flex items-start selectWrap">
      <ad-form
        :filedList="filedList"
        v-model="formData"
        :formPrams="formPrams"
        @change="change"
      >
      </ad-form>
      <el-form>
        <el-form-item>
          <el-select
            v-model="proName"
            placeholder="请输入产品名称查询"
            size="mini"
            filterable
            remote
            clearable
            :remote-method="getProductId"
            v-loading="productLoading"
            @change="changeProductName"
            v-loadMoreSelect="f_loadMoreSelect"
            ><el-option
              v-for="item in productLists"
              :key="item.id"
              :label="item.product_name"
              :value="item.id"
            ></el-option></el-select
        ></el-form-item>
      </el-form>
    </div>

    <div
      v-if="materialList?.length > 0"
      class="flex flex-wrap"
    >
      <MaterialList :mainMenuList="materialList">
        <template v-slot:default="scope">
          <div
            class="imgWrap relative box-border p-2 cursor-pointer shadow-md rounded-lg"
            @click.stop="(event) => choose(event, scope.img.id, scope.img)"
          >
            <img
              v-if="scope.img.type == '1'"
              :src="scope.img.url"
              class="w-full h-full"
              fit="contain"
            />

            <div
              class="img relative"
              v-if="scope.img.type == '2'"
            >
              <video
                controls
                class="w-full h-full rounded-lg"
                :src="scope.img.url"
                :poster="scope.img.thumbUrl"
                :ref="`video${scope.img.id}`"
                @play="handlePlay(scope.img.id)"
              ></video>
            </div>
            <span
              class="absolute right-3 top-3 checkIcon"
              :class="[chooseList.indexOf(scope.img.id) >= 0 ? 'activeCheck' : '']"
              ><i class="el-icon-success"></i
            ></span>
            <el-tooltip
              effect="dark"
              :content="scope.img.file_name"
              placement="top"
            >
              <p class="text-gray-600 font-bold text-sm mt-1 text-wrap line-clamp-2 overflow-ellipsis w-full">
                {{ scope.img.file_name }}
              </p>
            </el-tooltip>

            <div class="flex items-center justify-between text-gray-400 text-xs mt-1">
              <p
                v-if="scope.img.type == '2'"
                class="mr-1"
              >
                {{ scope.img.play_time | gettimeFormat }}
              </p>
              <p>{{ scope.img.width }}*{{ scope.img.high }}</p>
              <el-tooltip
                effect="dark"
                :content="scope.img.platform || '暂无可支持的平台'"
                placement="bottom"
              >
                <is-platform-right-or-wrong
                  :platformString="scope.img.platform"
                  :platform="platform"
                ></is-platform-right-or-wrong>
              </el-tooltip>
            </div>

            <!-- 投放数据展示（materialListV2 指标11） -->
            <div class="mt-1">
              <el-popover
                placement="right"
                width="600"
                trigger="hover"
                popper-class="metrics-popover"
              >
                <div
                  v-if="metricsLoading"
                  class="metrics-empty"
                >
                  <i class="el-icon-loading"></i> 加载中...
                </div>
                <div
                  v-else-if="getMetrics(scope.img.md5_code)"
                  class="metrics-grid"
                >
                  <div class="box">
                    <p>展示次数</p>
                    <p>{{ formatNum(getMetrics(scope.img.md5_code).pv) }}</p>
                  </div>
                  <div class="box">
                    <p>点击次数</p>
                    <p>{{ formatNum(getMetrics(scope.img.md5_code).clicks_cnt) }}</p>
                  </div>
                  <div class="box">
                    <p>点击率</p>
                    <p>{{ formatRate(getMetrics(scope.img.md5_code).clicks_rate) }}</p>
                  </div>
                  <div class="box">
                    <p>转化率</p>
                    <p>{{ formatRate(getMetrics(scope.img.md5_code).conversions_rate) }}</p>
                  </div>
                  <div class="box">
                    <p>订单量</p>
                    <p>{{ formatNum(getMetrics(scope.img.md5_code).order_cnt) }}</p>
                  </div>
                  <div class="box">
                    <p>转化成本</p>
                    <p>{{ formatAmount(getMetrics(scope.img.md5_code).conversion_cost) }}</p>
                  </div>
                  <div class="box">
                    <p>单次展示成本</p>
                    <p>{{ formatAmount(getMetrics(scope.img.md5_code).single_clicks_amt) }}</p>
                  </div>
                  <div class="box">
                    <p>单次加购成本</p>
                    <p>{{ formatAmount(getMetrics(scope.img.md5_code).single_cart_amt) }}</p>
                  </div>
                  <div class="box">
                    <p>下载次数</p>
                    <p>{{ formatNum(getMetrics(scope.img.md5_code).download_count) }}</p>
                  </div>
                  <div class="box">
                    <p>最后投放</p>
                    <p>{{ formatNum(getMetrics(scope.img.md5_code).last_ad_time) }}</p>
                  </div>
                </div>
                <div
                  v-else
                  class="metrics-empty"
                >
                  暂无投放数据
                </div>
                <span
                  slot="reference"
                  class="metrics-trigger"
                  @click.stop
                >
                  <i class="el-icon-data-line"></i> 查看数据
                </span>
              </el-popover>
            </div>
            <!-- 检测状态展示 - 视频标题下方 -->
            <div
              v-if="enableAuditStatus && scope.img.type == '2'"
              class="mt-2"
            >
              <el-tag
                v-if="auditStatusLoading"
                size="mini"
                type="info"
              >
                <i class="el-icon-loading"></i> 加载中...
              </el-tag>
              <template v-else-if="getAuditStatus(scope.img.id)">
                <!-- 违规状态 - 展示详细表格 -->
                <el-popover
                  v-if="getAuditStatus(scope.img.id).status === 3 && getAuditStatus(scope.img.id).reason"
                  placement="right"
                  width="600"
                  trigger="hover"
                  popper-class="reason-popover"
                >
                  <div class="reason-table-wrap">
                    <el-table
                      :data="parseViolationData(getAuditStatus(scope.img.id).reason)"
                      border
                      size="mini"
                      max-height="300"
                    >
                      <el-table-column
                        prop="label"
                        label="标签"
                        width="80"
                      />
                      <el-table-column
                        prop="sexy"
                        label="性感等级"
                        width="80"
                      />
                      <el-table-column
                        prop="description"
                        label="描述"
                        min-width="200"
                        show-overflow-tooltip
                      />
                      <el-table-column
                        prop="frame_position"
                        label="帧位置(秒)"
                        width="80"
                      />
                      <el-table-column
                        label="问题帧"
                        width="80"
                      >
                        <template slot-scope="{ row }">
                          <el-image
                            v-if="row.frame_url"
                            :src="row.frame_url"
                            :preview-src-list="[row.frame_url]"
                            style="width: 50px; height: 40px"
                            fit="cover"
                          />
                          <span v-else>-</span>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <el-tag
                    slot="reference"
                    size="mini"
                    :type="getAuditStatusTagType(getAuditStatus(scope.img.id).status)"
                    class="cursor-pointer"
                  >
                    <i :class="getAuditStatusIcon(getAuditStatus(scope.img.id).status)"></i>
                    {{ getAuditStatusText(scope.img.id) }}
                  </el-tag>
                </el-popover>
                <!-- 失败状态 - 只展示 msg 信息 -->
                <el-tooltip
                  v-else-if="getAuditStatus(scope.img.id).status === 4 && getAuditStatus(scope.img.id).reason"
                  effect="dark"
                  :content="parseFailureMsg(getAuditStatus(scope.img.id).reason)"
                  placement="top"
                >
                  <el-tag
                    size="mini"
                    :type="getAuditStatusTagType(getAuditStatus(scope.img.id).status)"
                    class="cursor-pointer"
                  >
                    <i :class="getAuditStatusIcon(getAuditStatus(scope.img.id).status)"></i>
                    {{ getAuditStatusText(scope.img.id) }}
                  </el-tag>
                </el-tooltip>
                <!-- 其他状态 - 无 popover -->
                <el-tag
                  v-else
                  size="mini"
                  :type="getAuditStatusTagType(getAuditStatus(scope.img.id).status)"
                >
                  <i :class="getAuditStatusIcon(getAuditStatus(scope.img.id).status)"></i>
                  {{ getAuditStatusText(scope.img.id) }}
                </el-tag>
              </template>
              <el-tag
                v-else
                size="mini"
                type="info"
              >
                <i class="el-icon-question"></i>
                未知
              </el-tag>
            </div>
          </div>
        </template>
      </MaterialList>

      <!-- <div v-for="(item, index) in materialList" :key="index"
                class="shadow-md imgWrap flex flex-col " @click="choose(item.id, item)">
                <div class="w-full  h-56 flex justify-center items-center">
                    <img v-if="item.type === '1'" class="w-full h-full" :src="item.url" fit="contain"></img>
                    <video v-if="item.type === '2'" class="w-full h-56" controls :src="item.url" :ref="`video${item.id}`" @play="handlePlay(item.id)"></video>
                </div>
                <span :class="[chooseList.indexOf(item.id) >= 0 ? 'active' : '']"><i class="el-icon-success"></i></span>
                <div class="w-full flex justify-between items-center gray text-sm h-5 px-5">
                    <div v-if="item.type === '2' && item.play_time" class="">{{ item.play_time }}</div>
                    <div v-if="item.width && item.high" class="">{{ item.width }}*{{ item.high }}</div>
                    <isPlatformRightOrWrong v-if="item.platform" :platformString='item.platform'></isPlatformRightOrWrong>
                </div>
                <div class="text-gray-600 font-bold text-sm mt-1 text-wrap ellipsis-1">{{ item.file_name }}</div>
            </div> -->
    </div>
    <el-empty
      v-else
      description="暂无数据"
    >
      <el-button
        icon="el-icon-refresh-right"
        circle
        @click="getList"
      ></el-button>
    </el-empty>
  </div>
</template>

<script>
import moment from 'moment';
import { queryGkLanguage, userSearch, productList } from '@/api/common/basic';
import { userFileRelateList, listAuditStatus, batchSubmitVideoRisk, materialListV2 } from '@adCommonComponent/serve/material';
import { MaterialList, adForm, isPlatformRightOrWrong } from '@adCommonComponent';
export default {
  // 组件名称
  name: 'PersonalMaterial',
  // 组件参数 接收来自父组件的数据
  props: {
    //是否打开弹窗 true打开 ，false关闭
    isOpen: {
      type: String,
      default: false,
    },
    // 商品ID 默认第一步填写商品
    saveAdFileParam: {
      type: Object,
      default: null,
    },
    uploadTypes: {
      type: String,
      default: 'img',
    },
    chooseList: {
      type: Array,
      default: () => [],
    },
    pageObj: {
      type: Object,
      default: () => {
        return {
          page: 0,
          pageSize: 10,
        };
      },
    },
    platform: {
      type: String,
      default: 'facebook',
    },
    showSelectAll: {
      type: Boolean,
      default: false,
    },
    // 是否启用检测状态功能
    enableAuditStatus: {
      type: Boolean,
      default: false,
    },
  },
  // 局部注册的组件
  components: { adForm, MaterialList, isPlatformRightOrWrong },
  // 组件状态值
  data() {
    return {
      formData: {
        pro_id: this.saveAdFileParam?.proId || '',
        lang_id: this.saveAdFileParam?.langId || '',
        platform: '',
        sale_id: '',
        sort_type: 1,
        upload_uid: '',
        media_type: '',
      },
      filedList: [
        {
          type: 'select',
          key: 'sort_type',
          placeholder: '请选择排序方式',
          options: [
            { name: '最新添加', id: 1 },
            { name: '最早添加', id: 2 },
          ],
          selectOptions: {
            size: 'mini',
          },
        },
        {
          type: 'input',
          key: 'pro_id',
          placeholder: '请输入产品ID',
          maxlength: 200,
          config: {
            clearable: true,
            size: 'mini',
          },
          validate: (value) => {
            if (!value) return true; // 无值不校验
            return /^\d+$/.test(value) || '产品ID必须是数字';
          },
        },
        {
          type: 'input',
          key: 'sale_id',
          placeholder: '请输入商品ID',
          config: {
            clearable: true,
            size: 'mini',
          },
          validate: (value) => {
            if (!value) return true; // 无值不校验
            return /^\d+$/.test(value) || '商品ID必须是数字';
          },
        },
        {
          type: 'select',
          key: 'lang_id',
          placeholder: '请选择语种',
          options: [],
          change: 'lang_id',
          refresh: false,
          'refresh-method': this.getLanguages,
          loading: false,
          selectOptions: {
            size: 'mini',
          },
        },
        {
          type: 'select',
          key: 'platform',
          placeholder: '请选择适用平台',
          options: [
            { name: 'facebook', id: 'facebook' },
            { name: 'tiktok', id: 'tiktok' },
            { name: 'google', id: 'google' },
            { name: 'snapchat', id: 'snapchat' },
            { name: 'line', id: 'line' },
            { name: 'twitter', id: 'twitter' },
          ],
          selectOptions: {
            size: 'mini',
          },
        },

        {
          type: 'select',
          key: 'upload_uid',
          placeholder: '请选择素材人员',
          loading: false,
          options: [],
          selectOptions: {
            filterable: true,
            remote: true,
            'remote-method': this.getUserSearch,
            size: 'mini',
          },
        },
      ],
      formPrams: {
        inline: true,
      },
      materialList: [],
      saleLoading: false,
      productLists: [],
      proName: '', // 产品名称
      productLoading: false,
      proParams: {
        page: 1,
        pageSize: 20,
        productName: '',
      },
      productTotalNumber: 0,
      isSelectAll: false,
      // 检测状态相关
      auditStatusMap: {}, // 视频ID -> 检测状态的映射
      auditStatusLoading: false, // 检测状态加载中标识
      submitLoading: false, // 提交中标识
      // 投放指标相关（materialListV2 副查询）
      metricsMap: {}, // md5_code(media_hash) -> 投放指标数据
      metricsLoading: false, // 指标加载中标识
    };
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {
    uploadTypes: {
      handler(val) {
        console.log(val, 'uploadTypes');

        if (val == 'img' || val == 'banner') {
          this.formData.media_type = '1';
        } else if (val == 'video') {
          this.formData.media_type = '2';
        }
      },
      immediate: true,
      deep: true,
    },
    'formData.pro_id': {
      handler(newVal, oldVal) {
        if (!newVal || newVal !== this.proName) {
          this.proName = '';
        }
      },
      immediate: true,
    },
    // 监听 chooseList 和 materialList 来同步全选状态
    chooseList: {
      handler() {
        this.updateSelectAllStatus();
      },
      deep: true,
    },
    materialList: {
      handler() {
        this.updateSelectAllStatus();
      },
      deep: true,
    },
  },
  filters: {
    gettimeFormat(second) {
      return moment.utc(second * 1000).format('mm:ss');
    },
  },
  // 组件方法
  methods: {
    updateSelectAllStatus() {
      if (!this.showSelectAll || this.materialList.length === 0) {
        this.isSelectAll = false;
        return;
      }
      // 检查当前页所有素材是否都被选中
      this.isSelectAll = this.materialList.every((item) => this.chooseList.includes(item.id));
    },
    handleSelectAll(val) {
      if (val) {
        // 全选：将当前页所有素材添加到选中列表
        this.materialList.forEach((item) => {
          if (!this.chooseList.includes(item.id)) {
            this.$emit('choose', item.id, item);
          }
        });
      } else {
        // 取消全选：将当前页所有素材从选中列表移除
        this.materialList.forEach((item) => {
          if (this.chooseList.includes(item.id)) {
            this.$emit('choose', item.id, item);
          }
        });
      }
    },
    handlePlay(id) {
      this.materialList.forEach((video) => {
        if (video.id !== id) {
          this.$refs[`video${video.id}`]?.pause();
        }
      });
    },
    choose(event, id, img) {
      event.preventDefault();
      // img.id = img.file_id;
      this.$emit('choose', id, img);
    },
    change(type, v) {
      console.log(type, v);
      if (type === 'upload_uid') {
        this.getUserSearch(v);
        return;
      }
      this.pageObj.page = 1;
      // this.$set(this.formData, type, v);
      this.getList();
    },
    async getList() {
      const params = await this.filterObject(this.formData);
      if (this.platform === 'snapchat') {
        params.width = 1080;
        params.high = 1920;
      }
      console.log(
        params,
        { ...params, platform: this.formData.platform, page: this.pageObj.page, size: this.pageObj.pageSize },
        '{...params, page: this.pageObj.page, size: this.pageObj.pageSize}',
      );

      this.$showLoading();
      userFileRelateList({ ...params, page: this.pageObj.page, size: this.pageObj.pageSize })
        .then((res) => {
          this.materialList = res.data.data;
          this.$emit('changeTotal', res.data.count);

          // 如果启用检测状态且是视频类型，批量查询检测状态
          if (this.enableAuditStatus && this.formData.media_type === '2') {
            const fileIds = res.data.data.map((item) => item.id);
            this.fetchVideoAuditStatus(fileIds);
          }

          // 用列表项的 md5_code 作为 media_hash，批量查询投放指标
          const md5s = (res.data.data || []).map((item) => item.md5_code).filter(Boolean);
          if (md5s.length) this.fetchMetrics(md5s);
        })
        .finally(() => {
          this.$hideLoading();
        });
    },
    filterObject(obj) {
      console.log(obj, 'obj');

      let filteredObj = {};
      for (let key in obj) {
        if (obj[key] !== null && obj[key] !== '') {
          filteredObj[key] = obj[key];
        }
      }
      return filteredObj;
    },
    changeProductName(v) {
      this.formData.pro_id = v;
      this.change();
    },
    getProductId(params) {
      this.proParams.productName = params;
      if (!this.proParams.productName) return;
      this.productLists = [];
      this.proParams.page = 1;
      this.f_productList();
    },
    f_productList() {
      if (this.productLists.length === this.productTotalNumber && this.productTotalNumber > 0) {
        return;
      }
      // this.$showLoading();
      this.productLoading = true;
      productList(this.proParams)
        .then((res) => {
          this.productLists = [...this.productLists, ...res.data.list];
          this.productTotalNumber = res.data.page.total_number;
        })
        .finally(() => {
          this.productLoading = false;
        });
    },
    f_loadMoreSelect() {
      this.proParams.page++;
      this.f_productList();
    },
    getLanguages() {
      const option = this.filedList.find((item) => {
        if (item.key === 'lang_id') {
          return item;
        }
      });
      option.loading = true;
      queryGkLanguage()
        .then((res) => {
          option.options = res.data;
        })
        .finally(() => {
          option.loading = false;
        });
    },
    getUserSearch(params) {
      let uidOption = this.filedList.find((item) => {
        if (item.key === 'upload_uid') {
          return item;
        }
      });
      uidOption.loading = true;
      userSearch({ name: params })
        .then((res) => {
          uidOption.options = res.data;
        })
        .finally(() => {
          uidOption.loading = false;
        });
    },
    close() {
      this.formData = {
        pro_id: '',
        lang_id: '',
        sale_id: '',
        // platform: this.platform,
        sort_type: 1,
        upload_uid: '',
        media_type: '',
      };
      this.proName = '';
      this.auditStatusMap = {};
      this.metricsMap = {};
      this.$destroy();
    },
    // 批量获取视频检测状态
    async fetchVideoAuditStatus(fileIds) {
      if (!this.enableAuditStatus || !fileIds.length) return;
      this.auditStatusLoading = true;
      try {
        const res = await listAuditStatus({
          materialType: 2, // 视频类型
          fileIds,
        });
        // 将数组转换为 Map 便于查找
        const statusMap = {};
        if (res.data && Array.isArray(res.data)) {
          res.data.forEach((item) => {
            statusMap[item.fileId] = {
              status: item.status,
              statusDesc: item.statusDesc,
              materialId: item.materialId,
              reason: item.reason || '', // 违规或失败原因
            };
          });
        }
        this.auditStatusMap = statusMap;
      } catch (error) {
        console.error('获取检测状态失败:', error);
        // 失败时不阻塞用户操作
      } finally {
        this.auditStatusLoading = false;
      }
    },
    // 批量查询素材投放指标（用 md5_code 作为 media_hash）
    async fetchMetrics(md5s) {
      if (!md5s || !md5s.length) return;
      this.metricsLoading = true;
      try {
        // 组装查询参数（与列表查询口径对齐，空值不传）
        const params = {
          media_hash: [...new Set(md5s)].join(','),
          platform: this.formData.platform || this.platform, // 表单适用平台优先，否则当前大平台
          current: 1,
          size: 15,
        };
        // get_type 与 media_type 编码相反：media_type 1图片/2视频 → get_type 1视频/2图片
        if (this.formData.media_type === '2') params.get_type = 1;
        else if (this.formData.media_type === '1') params.get_type = 2;
        // 产品ID / 语种（有值才传）
        if (this.formData.pro_id) params.product_id = Number(this.formData.pro_id);
        if (this.formData.lang_id) params.language_id = this.formData.lang_id;
        const res = await materialListV2(params);
        const map = {};
        const records = res?.data?.records || [];
        records.forEach((item) => {
          // 同一 media_hash 可能因不同平台/产品/市场返回多条，这里只取第一条展示
          if (item.media_hash && !map[item.media_hash]) {
            map[item.media_hash] = item;
          }
        });
        this.metricsMap = map;
      } catch (error) {
        console.error('获取素材投放指标失败:', error);
        // 失败不阻塞列表展示
      } finally {
        this.metricsLoading = false;
      }
    },
    // 获取单个素材的投放指标（按 md5_code 取）
    getMetrics(md5) {
      return md5 ? this.metricsMap[md5] || null : null;
    },
    // 指标格式化：比率（小数转百分比）
    formatRate(v) {
      const n = parseFloat(v);
      return isNaN(n) ? '-' : (n * 100).toFixed(2) + '%';
    },
    // 指标格式化：金额（保留两位小数）
    formatAmount(v) {
      const n = parseFloat(v);
      return isNaN(n) ? '-' : n.toFixed(2);
    },
    // 指标格式化：普通数值（空值兜底）
    formatNum(v) {
      return v === undefined || v === null || v === '' ? '-' : v;
    },
    // 获取单个视频的检测状态
    getAuditStatus(fileId) {
      return this.auditStatusMap[fileId] || null;
    },
    // 获取检测状态的展示样式类（根据 status 数值判断）
    // 0-待检测 1-检测中 2-通过 3-违规 4-失败
    getAuditStatusClass(status) {
      const classMap = {
        0: 'text-gray-400', // 待检测
        1: 'text-orange-500', // 检测中
        2: 'text-green-500', // 通过
        3: 'text-red-500', // 违规
        4: 'text-red-500', // 失败
      };
      return classMap[status] ?? 'text-gray-400';
    },
    // 获取检测状态标签样式类（带圆点的标签样式）
    // 0-待检测 1-检测中 2-通过 3-违规 4-失败
    getAuditStatusTagClass(status) {
      const classMap = {
        0: 'audit-status-pending', // 待检测 - 灰色
        1: 'audit-status-checking', // 检测中/待审核 - 橙色
        2: 'audit-status-passed', // 检测通过 - 绿色
        3: 'audit-status-rejected', // 未通过/违规 - 红色
        4: 'audit-status-failed', // 失败 - 红色
      };
      return classMap[status] ?? 'audit-status-unknown';
    },
    // 获取 el-tag 的 type 属性
    // 0-待检测 1-检测中 2-通过 3-违规 4-失败
    getAuditStatusTagType(status) {
      const typeMap = {
        0: 'info', // 待检测 - 灰色
        1: 'warning', // 检测中/待审核 - 橙色
        2: 'success', // 检测通过 - 绿色
        3: 'danger', // 未通过/违规 - 红色
        4: 'danger', // 失败 - 红色
      };
      return typeMap[status] ?? 'info';
    },
    // 获取检测状态图标类
    // 0-待检测 1-检测中 2-通过 3-违规 4-失败
    getAuditStatusIcon(status) {
      const iconMap = {
        0: 'el-icon-time', // 待检测
        1: 'el-icon-warning', // 检测中/待审核
        2: 'el-icon-circle-check', // 检测通过
        3: 'el-icon-circle-close', // 未通过/违规
        4: 'el-icon-circle-close', // 失败
      };
      return iconMap[status] ?? 'el-icon-question';
    },
    // 获取检测状态的展示文本（直接使用接口返回的 statusDesc）
    getAuditStatusText(fileId) {
      const statusInfo = this.auditStatusMap[fileId];
      return statusInfo?.statusDesc || '未知';
    },
    // 解析 reason 数据为表格格式
    parseReasonData(reason) {
      if (!reason) return [];
      try {
        const reasonData = typeof reason === 'string' ? JSON.parse(reason) : reason;
        const tableData = [];
        if (Array.isArray(reasonData)) {
          reasonData.forEach((item) => {
            const data = item.data || {};
            const label = data.label || '';
            const resultTypes = ['sexy_high', 'sexy_low', 'porn'];
            resultTypes.forEach((type) => {
              if (data[type] && Array.isArray(data[type]) && data[type].length > 0) {
                data[type].forEach((detail) => {
                  tableData.push({
                    label,
                    sexy: detail.sexy || '-',
                    porn: detail.porn || '-',
                    description: detail.description || '-',
                    frame_position: detail.frame_position ? detail.frame_position.toFixed(2) : '-',
                    frame_url: detail.frame_url || '',
                  });
                });
              }
            });
          });
        }
        return tableData;
      } catch (error) {
        console.error('解析检测详情失败:', error);
        return [];
      }
    },
    // 解析违规状态的 reason 数据（只解析 data 信息）
    parseViolationData(reason) {
      if (!reason) return [];
      try {
        const reasonData = typeof reason === 'string' ? JSON.parse(reason) : reason;
        const tableData = [];
        if (Array.isArray(reasonData)) {
          reasonData.forEach((item) => {
            const data = item.data || {};
            const label = data.label || '';
            const resultTypes = ['sexy_high', 'sexy_low', 'porn'];
            resultTypes.forEach((type) => {
              if (data[type] && Array.isArray(data[type]) && data[type].length > 0) {
                data[type].forEach((detail) => {
                  tableData.push({
                    label,
                    sexy: detail.sexy || '-',
                    porn: detail.porn || '-',
                    description: detail.description || '-',
                    frame_position: detail.frame_position ? detail.frame_position.toFixed(2) : '-',
                    frame_url: detail.frame_url || '',
                  });
                });
              }
            });
          });
        }
        return tableData;
      } catch (error) {
        console.error('解析违规详情失败:', error);
        return [];
      }
    },
    // 解析失败状态的 reason 数据（只返回 msg 字段）
    parseFailureMsg(reason) {
      if (!reason) return '检测失败';
      try {
        const reasonData = typeof reason === 'string' ? JSON.parse(reason) : reason;
        // 如果是数组，取第一个元素
        if (Array.isArray(reasonData) && reasonData.length > 0) {
          return reasonData[0].msg || '检测失败';
        }
        // 如果是对象，直接取 msg
        if (reasonData && typeof reasonData === 'object') {
          return reasonData.msg || '检测失败';
        }
        return '检测失败';
      } catch (error) {
        console.error('解析失败信息失败:', error);
        return '检测失败';
      }
    },
    // 批量提交素材检测（供父组件通过 ref 调用）
    // 参数: videoList - 视频列表, config - 配置项 { auditApiType, platform }
    async batchSubmitVideoRiskMethod(videoList, config = {}) {
      if (!videoList || !videoList.length) {
        return Promise.resolve({ success: true });
      }

      // 过滤出没有检测过的视频（auditStatusMap 中不存在的）
      const unauditedVideos = videoList.filter((item) => {
        return !this.auditStatusMap[item.id];
      });

      // 如果没有需要检测的视频，直接返回成功
      if (!unauditedVideos.length) {
        return Promise.resolve({ success: true });
      }

      this.submitLoading = true;
      try {
        // 构造批量提交的参数数组
        const submitList = unauditedVideos.map((item) => ({
          auditApiType: config.auditApiType || 'GIIKIN',
          fileId: item.id,
          uid: this.$store.state?.user?.userInfo?.data?.id || 0,
          platform: config.platform || 'google',
          materialId: item.materialId || null,
          materialType: item.type === '2' ? 'VIDEO' : 'IMAGE',
          materialUrl: item.url,
          creativeTitle: item.title || null,
          creativeBody: item.body || null,
        }));

        const res = await batchSubmitVideoRisk(submitList);
        return res;
      } catch (error) {
        console.error('批量提交素材检测失败:', error);
        throw error;
      } finally {
        this.submitLoading = false;
      }
    },
  },
  /**
   * 组件实例创建完成，属性已绑定，但DOM还未生成，$ el属性还不存在
   */
  async created() {
    this.getLanguages();
    this.getUserSearch('');
    // this.formData.platform = this.platform;
    await this.getList();
  },
  /**
   * el 被新创建的 vm.$ el 替换，并挂载到实例上去之后调用该钩子。
   * 如果 root 实例挂载了一个文档内元素，当 mounted 被调用时 vm.$ el 也在文档内。
   */
  mounted() {},
  /**
   * 实例销毁之前调用。在这一步，实例仍然完全可用。
   */
  beforeDestroy() {},
  /**
   * Vue 实例销毁后调用。调用后，Vue 实例指示的所有东西都会解绑定，
   * 所有的事件监听器会被移除，所有的子实例也会被销毁。
   */
  destroyed() {},
};
</script>

<style scoped lang="scss">
.wrapHeight {
  height: calc(100vh - 158px);
  overflow-y: scroll;
}
.selectWrap {
  ::v-deep .el-input {
    width: 165px; /* 使用 !important 避免被默认样式覆盖 */
  }
  ::v-deep .el-select {
    width: 165px; /* 使用 !important 避免被默认样式覆盖 */
  }
}
.imgWrap {
  background-color: #f5f5f5;

  &:hover {
    span {
      i {
        opacity: 0.6;
      }
    }
  }

  video {
    min-height: 233px;
  }

  span.checkIcon {
    position: absolute;
    right: 12px;
    top: 12px;
    &.activeCheck {
      i {
        color: #409eff;
        opacity: 1;
      }
    }
    i {
      font-size: 24px;
      color: #999;
      opacity: 0;
    }
  }

  // 检测状态行样式 - 确保正常换行显示
  .audit-status-row {
    position: relative;
    white-space: normal;
    word-wrap: break-word;
  }

  // 投放数据查看入口
  .metrics-trigger {
    display: inline-block;
    color: #409eff;
    font-size: 12px;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
    i {
      margin-right: 2px;
    }
  }
}

// popover 样式（需要放在 scoped 外部）
::v-deep .reason-popover {
  .reason-table-wrap {
    max-height: 350px;
    overflow-y: auto;
  }
}

// el-tag 内图标样式
::v-deep .el-tag {
  i {
    margin-right: 4px;
  }
}
</style>

<style lang="scss">
/* 投放指标 popover 内容样式：popper append-to-body 脱离组件 DOM 树,scoped 无法命中,必须全局非 scoped + popper-class 前缀 */
.metrics-popover {
  .metrics-grid {
    display: flex;
    flex-wrap: wrap;
    .box {
      width: 25%;
      margin-bottom: 6px;
      p:first-child {
        color: #606266;
        font-size: 12px;
      }
      p:last-child {
        color: red;
        font-size: 13px;
        margin-top: 3px;
        word-break: break-all;
      }
    }
  }
  .metrics-empty {
    text-align: center;
    color: #909399;
    font-size: 12px;
    padding: 16px 0;
  }
}
</style>
